"use client"

import { DropStatus } from "@anaconda/core/drop/types"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { DropStatusBadge } from "../status/drop-status"
import { DropStatusDate } from "../status/drop-status-date"
import { DropMoleculeReatom } from "../store/drop-store.reatom"
import { useDropStatusReatom } from "../store/hooks.reatom"
import { usePhaseStatus } from "./use-phase-status"

export const MintStatus = reatomComponent(
  ({ phaseNumber }: { phaseNumber: number }) => {
    const { isLimitedEditionAtom, phasesAtom } = useMolecule(DropMoleculeReatom)
    const isLimitedEdition = isLimitedEditionAtom()
    const phases = phasesAtom()
    const { lastActivityDataAtom } = useDropStatusReatom()
    const isLoading = !lastActivityDataAtom.ready()
    const lastActivityTime = lastActivityDataAtom.data()

    const phaseStatus = usePhaseStatus(phaseNumber)
    const phase = phases[phaseNumber]

    // Only show loading skeleton if we need lastActivityTime and it's not ready
    // lastActivityTime is only needed when: status is Ended AND isLimitedEdition is true
    const needsActivityTime =
      phaseStatus === DropStatus.Ended && isLimitedEdition

    if (isLoading && needsActivityTime) {
      return <Skeleton className="h-5 w-24" />
    }

    return (
      <DropStatusBadge status={phaseStatus}>
        <DropStatusDate
          data={{
            status: phaseStatus,
            isLimitedEdition,
            lastActivityTime: lastActivityTime ?? null,
            startDate: phase.startDate,
            endDate: phase.endDate ?? null,
          }}
        />
      </DropStatusBadge>
    )
  },
  "MintStatus",
)
